import Typography from "@mui/material/Typography";
import IconButton from "@mui/material/IconButton";
import CloseIcon from "@mui/icons-material/Close";
import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
    container: {
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: theme.spacing(1),
    },
    error: {
        fontWeight: "bold",
        fontSize: "20px",
        color: "red",
    },
    success: {
        textAlign: "center",
        fontWeight: "bold",
        fontSize: "20px",
        color: "green",
    },
}));

export default function DismissibleMessage({ message, type, onDismiss }) {
    const classes = useStyles();

    if (!message) {
        return null;
    }

    const isError = type === "error";
    const textClass = isError ? classes.error : classes.success;
    const iconColor = isError ? "red" : "green";

    return (
        <div className={classes.container}>
            <Typography className={textClass} sx={{ whiteSpace: "pre-line" }}>{message}</Typography>
            <IconButton size="small" onClick={onDismiss} sx={{ ml: 1, color: iconColor }}>
                <CloseIcon />
            </IconButton>
        </div>
    );
}
